import { Button } from '@mui/material';
import { useMessageListContext } from '@mui/x-chat/headless';
import { ArrowDownIcon } from '@phosphor-icons/react';
import { useRef } from 'react';

import { isDefined } from 'common';

export function AgenticChatScrollToBottomButton() {
  const messageList = useMessageListContext();
  const hasScrolledOnOpen = useRef(false);

  return (
    <Button
      ref={(element: HTMLButtonElement | null) => {
        // MUI Chat 9.0.0-alpha.16 auto-scrolls new messages, but not initially loaded history.
        if (isDefined(element) && !hasScrolledOnOpen.current) {
          hasScrolledOnOpen.current = true;
          messageList.scrollToBottom({ behavior: 'auto' });
        }
      }}
      variant="contained"
      size="small"
      startIcon={<ArrowDownIcon size={14} aria-hidden />}
      aria-label="Scroll to latest message"
      onClick={() =>
        messageList.scrollToBottom({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
        })
      }
      sx={{
        display: messageList.isAtBottom ? 'none' : undefined,
        position: 'absolute',
        bottom: (theme) => theme.spacing(2),
        zIndex: 2,
        left: '50%',
        transform: 'translateX(-50%)',
        pointerEvents: 'auto',
        minWidth: 0,
        paddingX: 1,
        paddingY: 0.25,
      }}
    >
      Latest message
    </Button>
  );
}
